import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import styled from "styled-components";
import { Color } from "../../theme/Color";
import { FontSizes } from "../../theme/FontSize";
import { RoundedCorners } from "../../theme/Mixins";

interface Props {
  title: string;
  link: string;
  isBold?: boolean;
  isActive?: boolean;
  isParent?: boolean;
  styleAsBlock?: boolean;
  color?: string;
  isChildMenuItem?: boolean;
  margin?: string;
}

const StyledLink = styled.a<{
  isBold: boolean;
  styleAsBlock?: boolean;
  color: string;
  isChildMenuItem?: boolean;
  margin: string;
}>`
  display: ${({ styleAsBlock }) => (styleAsBlock ? "block" : "flex")};
  align-items: center;
  font-size: ${FontSizes[-1]};
  font-weight: ${({ isBold }) => (isBold ? "bold" : "")};
  margin: ${({ margin }) => (margin ? margin : "0 1rem 0 0")};
  padding: 0.5rem 0.8rem;
  text-decoration: none;
  max-width: 200px;
  text-align: ${({ isChildMenuItem }) => (isChildMenuItem ? "left" : "center")};
  min-height: ${({ isChildMenuItem }) => (isChildMenuItem ? "45px" : "65px")};
  ${RoundedCorners};
  color: ${({ color }) => (color ? color : Color.Orange5)};

  transition: all 0.4s ease;

  &:hover {
    background: ${Color.Blue9};
    cursor: pointer;
  }
  &.active {
    background: ${Color.Blue9};
  }

  @media (max-width: 1292px) {
    max-width: 150px;
    line-height: 1;
  }
`;

const MenuItem = ({
  title,
  link,
  isBold = false,
  isActive = false,
  isParent = false,
  styleAsBlock = false,
  color = Color.Orange5,
  isChildMenuItem = false,
  margin = "0 1rem 0 0",
}: Props) => {
  return (
    <Link href={link} style={{ display: "inline-block" }} passHref>
      <StyledLink
        className={isActive ? "active" : "not-active"}
        isBold={isBold}
        styleAsBlock={styleAsBlock}
        style={{ color: color }}
        color={color}
        isChildMenuItem={isChildMenuItem}
        margin={margin}
      >
        {title}
        {isParent && (
          <FontAwesomeIcon
            icon={faChevronDown}
            style={{ margin: "0 0 0 0.3rem" }}
          />
        )}
      </StyledLink>
    </Link>
  );
};

export default MenuItem;
